import { getAxiosBackendMubinApi } from "../helpers/axios"

class MubinApiServices{
    
    constructor(){
    }

    checkcode(code){
        return getAxiosBackendMubinApi().get(code)
    }
}

export default new MubinApiServices()